import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RedocStandalone } from 'redoc';
import { celticBlue, appleGreen, orangeYellow, madderLake, cultured, oxfordBlue, primaryFont, solitude, darkMoss, hexToRgba, peppermint, tutu, monospaceFont, silverPearl, smallBreakpoint, mediumBreakpoint, largeBreakpoint, FAB, } from '@phishtool/ui';
import { useEffect, useState } from 'react';
const useFAB = () => {
    const menuSelector = '.menu-content';
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        const menu = document.querySelector(menuSelector);
        menu === null || menu === void 0 ? void 0 : menu.classList.toggle('is-open', isOpen);
    }, [isOpen]);
    return [isOpen, setIsOpen];
};
const Home = () => {
    const [isOpen, setIsOpen] = useFAB();
    const specUrl = `/spec.json`;
    useEffect(() => {
        document.body.classList.add('redoc');
        return () => {
            document.body.classList.remove('redoc');
        };
    }, []);
    return (_jsxs("div", Object.assign({ className: "redoc-content" }, { children: [_jsx(RedocStandalone, { specUrl: specUrl, options: {
                    hideFab: true,
                    showWebhookVerb: true,
                    showObjectSchemaExamples: true,
                    disableSearch: true,
                    hideDownloadButton: true,
                    sortPropsAlphabetically: true,
                    scrollYOffset: 40,
                    theme: {
                        breakpoints: {
                            small: `${smallBreakpoint}px`,
                            medium: `${mediumBreakpoint}px`,
                            large: `${largeBreakpoint}px`,
                        },
                        spacing: {
                            unit: 5,
                            sectionHorizontal: 20,
                            sectionVertical: ({ spacing }) => spacing.unit * 4,
                        },
                        colors: {
                            text: {
                                primary: oxfordBlue,
                                secondary: oxfordBlue,
                            },
                            primary: {
                                main: celticBlue,
                            },
                            success: {
                                main: appleGreen,
                            },
                            warning: {
                                main: orangeYellow,
                            },
                            error: {
                                main: madderLake,
                            },
                            responses: {
                                success: {
                                    color: darkMoss,
                                    backgroundColor: hexToRgba(peppermint, 0.4),
                                    tabTextColor: ({ colors }) => colors.responses.success.color,
                                },
                                error: {
                                    color: madderLake,
                                    backgroundColor: hexToRgba(tutu, 0.4),
                                    tabTextColor: ({ colors }) => colors.responses.error.color,
                                },
                            },
                        },
                        typography: {
                            fontFamily: primaryFont,
                            headings: {
                                fontFamily: primaryFont,
                            },
                            code: {
                                fontSize: '13px',
                                fontFamily: monospaceFont,
                            },
                        },
                        sidebar: {
                            backgroundColor: cultured,
                            textColor: oxfordBlue,
                            groupItems: {
                                activeBackgroundColor: silverPearl,
                            },
                            level1Items: {
                                activeBackgroundColor: silverPearl,
                            },
                        },
                        rightPanel: {
                            backgroundColor: solitude,
                        },
                        codeBlock: {
                            backgroundColor: oxfordBlue,
                        },
                    },
                } }), _jsx(FAB, { isOpen: isOpen, setIsOpen: setIsOpen })] })));
};
export default Home;
